// Registers runtime MF remotes; isolated so the MF runtime stays off the env.js read path.
import { registerRemotes } from '@module-federation/enhanced/runtime';

const RUNTIME_REMOTES = [
  { name: 'shipbob_design_system', settingKey: 'SHIPBOB_DESIGN_SYSTEM', required: true },
  { name: 'shipbob_mfe_runtime', settingKey: 'SHIPBOB_MFE_RUNTIME', required: true },
];

/**
 * Register all MF runtime remotes from app settings.
 * Returns false if any required remote URL is missing or invalid.
 *
 * @param {Object} appSettings - Loaded app settings object
 * @returns {boolean} true if all required remotes were registered
 */
export function registerRuntimeRemotes(appSettings) {
  const settings = appSettings || {};
  const missingRequired = [];

  RUNTIME_REMOTES.forEach(({ name, settingKey, required }) => {
    const value = settings[settingKey];
    if (typeof value !== 'string' || !value.trim()) {
      console.error(`[UserManagementUI] ${settingKey} missing or invalid in app settings; skipping ${name} remote`);
      if (required) missingRequired.push(settingKey);
      return;
    }
    const origin = value.trim().replace(/\/$/, '');
    registerRemotes([{ name, entry: `${origin}/remoteEntry.js` }], { force: true });
  });

  return missingRequired.length === 0;
}
